import { useState, useEffect } from "react";
import TextFieldList from "./TextFieldList";
import LanguageValueField from "./LanguageValueField";
import LanguageValueList from "../formModels/LanguageValueList";
// import AdmsIdentifierListView from "./AdmsIdentifierListView";
import { Typography, Stack } from "@mui/material";
import { isFieldRequired, getTitleByField, getDescriptionByField } from "../config/commonFunctions";
import Person from "../formModels/Person";
// import AdmsIdentifierList from "../formModels/AdmsIdentifierList";

export default function PersonSingle(props) {
    const [person, setPerson] = useState(props.initialPerson);
    const { required, schemaAsObject } = props; // error, validationError
    // console.log(validationError?.email);

    useEffect(() => {
        if (props.initialPerson) {
            setPerson(props.initialPerson);
        } else {
            setPerson(new Person());  // Initialize with an empty Person object if missing
        }
    }, [props.initialPerson]);

    // Update function for street address field
    const handleNameChange = (updatedValues) => {
        if (updatedValues instanceof LanguageValueList) {
            // const newStreetAddress = new LanguageValueList(updatedValues);
            const updatedPerson = new Person(
                // person.getIdentifiers(),
                updatedValues,
                person.getEmails(),
                person.getId()
            );
            setPerson(updatedPerson);
            props.onChange(updatedPerson); // Pass the updated person back to parent
        }
    };

    /*
     const handleWebsitesChange = (updatedWebsites) => {
         const updatedPerson = new Person(
             // person.getIdentifiers(),
             person.getName(),
             // updatedWebsites,
             person.getEmails()
         );
         setPerson(updatedPerson);
         props.onChange(updatedPerson); // Pass the updated person back to parent
     }; */

    // Handle emails change
    const handleEmailsChange = (updatedEmails) => {
        // Create a copy of the person instance and update emails
        const updatedPerson = new Person(
            // person.getIdentifiers(),
            person.getName(),
            // person.getWebsites(),
            updatedEmails,
            person.getId(),
        );
        setPerson(updatedPerson);
        props.onChange(updatedPerson); // Pass the updated person back to parent
    };


    /* const handleIdentifierChange = (updatedIdentifiers) => {
        const updatedPerson = new Person(
            new AdmsIdentifierList(updatedIdentifiers),
            person.getName(),
            person.getWebsites(),
            person.getEmails()
        );
        setPerson(updatedPerson);
        props.onChange(updatedPerson);
    }; */
    // console.log(schemaAsObject);
    return (
        <Stack spacing={2}>
            <fieldset>
                <legend>
                    <div>
                        <Typography variant="h6">{props.title} {required && <span>*</span>} </Typography>
                        <Typography variant="p">{props.subtitle}</Typography>
                    </div>
                </legend>
                <div style={{paddingTop: "1em"}}>
                    <LanguageValueField
                        id={`${props.title}-name`}
                        label={getTitleByField(schemaAsObject, "Person.name")}
                        helperText={getDescriptionByField(schemaAsObject, "Person.name")}
                        obj={person.getName()}
                        lang={props.lang}
                        onChange={handleNameChange}
                        required={props.requirementException === false ? isFieldRequired("name", schemaAsObject?.$defs?.Person) : false}
                        // error={error ? !!error.name : false}
                    />

                    {/* Emails field */}
                    <TextFieldList
                        id={`${props.title}-email`}
                        title={getTitleByField(schemaAsObject, "Person.email")}
                        helperText={getDescriptionByField(schemaAsObject, "Person.email")}
                        subtitle={getDescriptionByField(schemaAsObject, "Person.email")}
                        values={person.getEmails()}
                        onChange={handleEmailsChange}
                        required={props.requirementException === false ? isFieldRequired("email", schemaAsObject?.$defs?.Person) : false}
                        // error={error ? !!error.email : false}
                    />
                </div>

            </fieldset>
        </Stack>
    );
}
